import { type MetaFunction } from '@remix-run/node'
import mainstreetamerica from './mainstreetamerica.png'

export const meta: MetaFunction = () => [
	{ title: 'Main Street America Group' },
	{
		name: 'description',
		content: 'We offer insurance from Main Street America Group.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">
				The Main Street America Group
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img
					src={mainstreetamerica}
					alt="Main Street America"
					className="w-64"
				/>

				<h3>A Long History of Service</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					The Main Street America Group was founded in 1923 in Keene, N.H. when
					the Grange Fraternity created an entity to provide affordable
					insurance to its members. Today, Main Street America, a super-regional
					property and casualty company, provides personal lines, commercial
					lines, and fidelity and surety bond products to individuals, families,
					and small businesses in 22 States through five carriers: NGM Insurance
					Company, Old Dominion Insurance Company, Main Street America Assurance
					Company, MSA Insurance Company, and Great Lakes Casualty Insurance
					Company. They are headquartered in Jacksonville F.L. with field
					offices throughout the United States.
				</p>
				<h3>Backed by Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Main Street America's products and services are backed by financial
					strength. They are rated "A" (Excellent) by A.M. Best, the insurance
					industry's premier rating organization.
				</p>
				<h3>A Full Product Line</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					For consumers, they offer competitively priced homeowners, auto, and
					umbrella products. Their commercial product line includes
					businessowners policy, commercial auto, workers' compensation, and
					umbrella. They also provide contract/construction, fidelity, and
					commercial surety bond products for a wide range of businesses and
					individuals.
				</p>
				<h3>Delivering Exceptional Customer Service</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					The Main Street America Group was recently ranked #3 for automobile
					claims satisfaction by the NY State Insurance department. This is a
					ranking they are very proud of.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://msainsurance.com/"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://msainsurance.com/ (opens in a new tab)
					</a>
				</p>
				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					(877) 425-2467
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Main Street America Billing"
						href="https://msainsurance.com/pay-my-bill"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://msainsurance.com/pay-my-bill (opens in a new tab)
					</a>
					<br />
					<br />
					Billing Address:
					<br />
					55 West Street
					<br />
					Keene, NH 03431
				</p>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Writing Companies
					<ul>
						<li>NGM Insurance Company</li>
						<li>Old Dominion Insurance Company</li>
						<li>Main Street America Assurance Company</li>
						<li>MSA Insurance Company</li>
						<li>Great Lakes Casualty Insurance Company</li>
						<li>Main Street America Protection Insurance Company</li>
					</ul>
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					The Main Street America Group
					<br />
					4601 Touchton Road East, Suite 3400
					<br />
					Jacksonville, FL 32246
				</p>
			</section>
		</main>
	)
}
